import useFetchItem from "../useFetchItem";
import HttpService from "../httpServices";
import { routes } from "../apiroutes";
import { ErrorHandler } from "../errorHandler";

const httpService = new HttpService();

/**
 * Get customer roles and permissions
 * This endpoint provides detailed role information including:
 * - customer_role: The exact role (PAYROLL_VIEWER, HR_MANAGER, etc.)
 * - plan information
 * - feature access
 * - employee limits
 */
export const useGetCustomerRoles = (options = {}) => {
  const { data, error, isLoading, refetch } = useFetchItem({
    queryKey: ['customerRoles'],
    queryFn: () => httpService.getData(routes.getCustomerRoles()),
    enabled: options.enabled !== false,
    retry: 2,
    onError: (err) => {
      const error = ErrorHandler(err);
      console.warn('Customer roles error:', error);
    },
  });

  // Extract the actual data from the Axios response
  const customerRolesData = data?.data || data;

  return {
    customerRoles: customerRolesData,
    customerRolesError: ErrorHandler(error),
    customerRolesIsLoading: isLoading,
    refetchCustomerRoles: refetch,
  };
};

const customerRolesService = {
  useGetCustomerRoles,
};

export default customerRolesService;